document.addEventListener('DOMContentLoaded', function () {
  const initBundleSwiper = () => {
    if (typeof Swiper === 'undefined') {
      setTimeout(initBundleSwiper, 100);
      return;
    }
    document.querySelectorAll('[data-bundle-swiper]').forEach(function (wrapper) {
      var id = wrapper.dataset.bundleSwiper;
      new Swiper('.upsell-swiper-' + id, {
        slidesPerView: 2.5,
        spaceBetween: 8,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        pagination: {
          el: wrapper.querySelector('.upsell-pagination'),
          clickable: true,
        },
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          300: { slidesPerView: 1.5, spaceBetween: 8 },
          640: { slidesPerView: 2.5, spaceBetween: 12 },
        }
      });
    });
  };
  initBundleSwiper();
});
